export default __webpack_public_path__ + "static/media/zfzzjhImg.38d7214a.png";